import * as form from '../../form';
import * as file from '../../file';
import {Template} from '../../template';
import {i18n} from '../i18n';

class AttachmentUploader extends file.AttachmentUploader {
  constructor(page: UploadRequestPage, readonly multiple: boolean) {
    super(page);
  }
  showUploadButton() {
    return this.multiple ? this.count < 5 : this.count == 0;
  }
  protected createFileInputValidator(input: HTMLInputElement) {
    return new file.FileInputValidator(input, 25, this.count);
  }
  protected override createClientAttachment(name: string, file: File) {
    return new ClientAttachment(this, `${name}[]`, file);
  }
}

class ClientAttachment extends file.ClientAttachment<AttachmentUploader> {
}

class UploadRequestPage {
  readonly uploader;
  readonly template: Template;
  readonly onformdata = (event: FormDataEvent) => {
    this.uploader.onformdata(event.formData);
  };
  readonly onsubmit = (event: SubmitEvent) => {
    const input =
      this.template.reference(this.uploader, 'file') as HTMLInputElement;
    if (!input)
      return;
    input.classList.remove('invalid-input');
    input.setCustomValidity('');
    if (this.uploader.count > 0) {
      form.Form.showLoadingModal();
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    input.classList.add('invalid-input');
    input.setCustomValidity(i18n('required'));
    input.scrollIntoView({block: 'center'});
    input.reportValidity();
  };
  constructor() {
    const element = document.querySelector('#upload-request') as HTMLElement;
    const root = element.parentElement!;
    element.remove();
    const data = JSON.parse(element.dataset['json']!);
    this.uploader = new AttachmentUploader(this, data['multiple']);
    this.template = new Template(element, root, this);
  }
}

if (/\/upload_request\?token=/.test(location.href)) {
  window.addEventListener('load', () => {
    new UploadRequestPage;
  });
}
